/* U20 footer independent goldfish school — V6.4.6 resilient desktop loading */
(function () {
  'use strict';

  var FOOTER_SELECTOR = '[data-u20-goldfish-footer]';
  var SCHOOL_SELECTOR = '[data-u20-goldfish-school]';
  var RUNTIME_KEY = '__u20FooterGoldfishRuntimeV646';

  // Shopify may execute a section-local script again when the footer section is
  // reloaded in the Theme Editor. Reuse the existing runtime instead of adding
  // another pair of global section listeners.
  if (window[RUNTIME_KEY]) {
    window[RUNTIME_KEY].initWithin(document);
    return;
  }

  var instances = new WeakMap();

  /* V45.8.305 — same CSS-viewport policy as Product World.
     At 1920px desktop width, the historical horizontal escape bound is
     1920 × 0.36 = 691.2px. Wider viewports increase both the destination
     distance and initial swim speed proportionally so fish cannot decay into
     a permanent low-speed "escape" state before reaching settle/orbit. */
  var DESKTOP_REFERENCE_WIDTH = 1920;
  var DESKTOP_REFERENCE_ESCAPE_BOUND = DESKTOP_REFERENCE_WIDTH * 0.36;
  var CLUSTERED_FRAME_INTERVAL = 1000 / 15;
  var MOBILE_QUERY = '(max-width: 749px)';
  var DESKTOP_QUERY = '(min-width: 750px)';
  var DESKTOP_PREWARM_VIEWPORTS = 2;
  var DESKTOP_PREWARM_MIN_DISTANCE = 1400;
  var DESKTOP_PREWARM_MAX_DISTANCE = 2400;
  var MOBILE_PREWARM_VIEWPORTS = 3;
  var MOBILE_PREWARM_MIN_DISTANCE = 2400;
  var MOBILE_PREWARM_MAX_DISTANCE = 3600;
  var MOBILE_WEBP_SUPPORTED = (function () {
    try {
      var canvas = document.createElement('canvas');
      return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } catch (error) {
      return false;
    }
  })();

  var ORBIT_HIT_BOUNDS = {"blue":[[119,8,197,75],[119,8,198,74],[120,7,201,74],[120,7,201,74],[123,6,204,73],[123,6,204,73],[125,5,206,72],[128,5,208,71],[128,5,209,71],[132,4,213,71],[132,4,212,71],[133,3,214,70],[136,2,218,70],[136,2,218,70],[138,1,222,69],[139,1,222,69],[141,1,225,68],[144,0,227,68],[144,0,227,68],[149,0,233,67],[149,0,233,67],[152,0,236,67],[155,0,239,66],[155,0,239,66],[161,0,244,66],[161,0,244,66],[164,0,248,65],[167,0,251,66],[167,0,251,66],[172,0,256,66],[173,0,256,66],[176,0,259,66],[178,0,263,66],[178,0,263,66],[182,0,268,67],[183,0,268,67],[186,0,271,67],[191,0,274,68],[191,0,274,68],[198,1,276,69],[198,1,276,68],[202,0,277,68],[208,0,276,70],[208,0,276,69],[217,1,279,67],[217,1,279,66],[223,2,279,68],[230,4,281,70],[230,3,280,70],[229,12,283,74],[229,12,283,74],[227,12,280,76],[225,13,280,78],[225,13,280,78],[223,22,282,82],[223,23,281,81],[221,25,281,82],[218,26,281,85],[218,26,281,85],[212,28,277,92],[212,28,277,93],[210,29,277,96],[207,31,278,98],[207,31,278,98],[203,33,279,101],[203,32,280,102],[201,34,280,102],[197,35,279,104],[197,35,279,104],[192,37,274,106],[191,37,276,107],[189,37,274,108],[186,37,270,109],[185,37,270,109],[180,40,270,111],[180,40,270,111],[177,41,268,111],[174,41,264,112],[174,41,264,112],[169,41,259,113],[169,41,259,113],[166,41,256,113],[162,43,253,114],[162,43,253,114],[158,44,250,114],[158,44,250,114],[156,43,247,114],[152,43,243,114],[152,43,243,114],[148,43,238,114],[148,43,238,114],[146,44,235,114],[143,43,232,113],[143,43,232,113],[140,40,228,113],[140,41,228,113],[138,42,225,112],[136,42,221,111],[136,42,221,111],[133,42,216,110],[133,42,216,110],[132,41,213,109],[131,41,209,108],[131,41,209,108],[130,39,204,105],[130,39,204,109],[128,42,202,108],[126,43,199,106],[126,43,199,106],[124,44,191,105],[124,44,191,106],[124,43,189,105],[122,41,186,103],[122,41,186,103],[120,38,181,97],[120,38,181,101],[119,36,178,99],[120,34,177,98],[120,34,177,98],[124,28,176,94],[124,28,176,94],[123,26,177,93],[122,25,178,90],[122,25,178,90],[121,23,181,85],[120,23,181,87],[120,21,182,85],[120,19,184,83],[120,19,184,83],[120,18,186,81],[120,17,186,81],[121,16,188,80],[122,14,190,79],[122,14,190,79],[122,13,193,77],[122,13,193,77],[121,12,194,75],[121,12,196,74],[121,12,196,74],[123,9,199,72]],"yellow":[[178,49,265,118],[177,49,264,118],[175,49,261,118],[175,49,262,118],[172,50,259,118],[172,49,260,118],[170,49,258,118],[168,49,255,118],[168,49,255,118],[165,49,251,118],[165,49,251,118],[164,49,249,118],[162,49,246,118],[162,49,246,118],[159,49,243,118],[158,49,244,118],[156,49,243,118],[154,49,240,118],[154,49,240,118],[150,49,237,117],[150,49,237,117],[149,48,235,117],[146,49,233,117],[146,49,233,117],[144,49,230,116],[144,48,230,116],[142,50,228,116],[140,48,227,116],[140,48,227,116],[141,49,217,115],[141,49,218,116],[141,51,213,116],[142,53,208,118],[142,53,208,118],[141,47,201,116],[141,48,201,116],[139,45,195,111],[139,45,193,114],[139,45,193,114],[139,40,193,109],[139,33,192,109],[136,32,232,106],[134,27,192,103],[134,27,192,103],[132,26,193,98],[132,23,193,98],[131,19,196,94],[131,15,200,89],[131,15,200,89],[129,10,205,82],[129,10,204,82],[128,9,207,79],[127,6,210,75],[127,6,210,75],[131,1,217,70],[131,2,217,70],[133,1,220,67],[138,0,225,65],[138,0,225,65],[145,0,232,62],[145,0,232,62],[149,0,235,61],[155,0,240,60],[155,0,240,60],[163,0,247,59],[163,0,247,59],[168,0,251,59],[174,0,256,59],[175,0,256,58],[182,0,262,59],[182,0,262,59],[186,0,265,59],[191,0,269,60],[191,0,269,60],[198,0,274,61],[198,0,274,61],[202,0,276,62],[206,0,280,65],[206,0,280,65],[211,3,284,69],[211,3,284,69],[213,5,285,71],[217,5,288,74],[217,5,288,74],[222,7,290,78],[223,6,290,78],[225,16,292,80],[228,17,294,83],[228,17,294,83],[229,23,295,87],[229,25,295,87],[229,25,295,88],[232,27,294,90],[232,28,294,90],[239,30,296,93],[239,30,295,93],[245,36,295,95],[246,49,295,97],[246,49,295,97],[240,44,295,106],[240,45,295,106],[237,43,296,109],[234,46,298,111],[234,46,298,111],[227,47,302,113],[227,47,302,113],[223,48,302,114],[218,48,301,115],[218,48,301,115],[212,46,297,114],[212,46,297,114],[208,48,294,115],[206,48,290,115],[206,48,290,115],[202,48,286,115],[202,48,287,115],[199,49,285,115],[198,48,284,116],[198,48,284,116],[194,49,281,117],[194,49,281,117],[193,49,280,117],[191,50,278,117],[191,50,278,117],[189,49,276,117],[189,49,276,117],[187,50,274,118],[186,50,272,118],[186,50,272,118],[184,49,271,118],[184,49,271,118],[183,49,270,118],[182,50,269,118],[182,50,269,118],[180,51,267,118],[180,51,267,117],[180,50,266,118],[178,50,264,118],[178,50,265,118],[176,50,262,118],[178,48,265,119]],"green":[[245,6,312,79],[246,7,312,81],[246,10,311,82],[246,9,311,82],[246,17,311,85],[246,17,311,85],[246,18,314,87],[246,18,316,88],[246,18,316,88],[245,18,319,91],[245,18,319,91],[244,20,319,93],[242,22,318,95],[242,22,318,95],[239,25,315,98],[239,25,315,98],[237,27,312,100],[236,30,311,102],[236,30,311,102],[233,33,309,105],[233,33,309,105],[232,35,308,107],[230,37,308,109],[230,37,308,109],[225,39,304,112],[225,40,304,112],[222,40,302,112],[219,43,298,115],[219,43,298,114],[214,45,293,117],[214,45,293,117],[212,47,291,118],[209,49,289,120],[209,49,289,119],[204,50,286,120],[204,50,286,120],[201,52,284,120],[197,53,280,120],[197,53,280,120],[191,54,273,120],[191,54,273,120],[188,54,270,120],[185,54,265,120],[185,54,265,120],[178,53,260,120],[179,53,260,120],[175,54,257,120],[171,54,254,120],[171,53,255,120],[165,51,252,120],[165,51,252,120],[160,52,249,120],[155,51,246,120],[155,51,246,120],[147,48,240,120],[147,48,239,120],[142,47,235,120],[137,46,230,120],[137,45,230,120],[128,42,222,120],[128,42,222,120],[123,39,219,117],[124,36,211,112],[124,36,210,113],[115,33,196,109],[115,33,196,109],[114,38,190,107],[114,34,183,105],[114,29,183,105],[119,25,175,100],[119,25,175,100],[117,18,178,96],[115,15,185,92],[115,15,185,92],[117,10,193,88],[117,10,193,88],[119,8,197,86],[121,6,202,84],[121,6,202,84],[121,4,208,81],[121,4,208,81],[120,2,211,79],[122,1,216,77],[122,1,216,77],[128,0,222,75],[128,0,222,75],[132,0,225,75],[136,0,229,74],[136,0,229,74],[142,0,235,72],[142,0,235,72],[146,0,238,71],[151,0,242,69],[151,0,242,70],[158,0,247,68],[158,0,246,68],[162,0,248,67],[167,0,250,67],[167,0,250,67],[173,0,253,66],[173,0,254,66],[177,0,255,66],[182,0,258,65],[182,0,258,65],[190,0,261,65],[190,0,261,65],[194,0,264,65],[199,0,267,65],[199,0,267,65],[204,0,272,65],[204,0,272,65],[208,0,274,65],[210,0,278,66],[211,0,277,66],[214,0,282,67],[214,0,282,67],[217,0,284,67],[220,0,287,67],[220,0,288,67],[224,0,291,68],[224,0,291,68],[226,0,294,68],[230,0,296,68],[230,0,296,68],[239,0,300,70],[239,0,300,70],[242,0,301,71],[243,3,302,72],[243,3,302,72],[244,3,300,74],[244,3,300,74],[245,8,299,75],[246,6,302,76],[246,6,302,76],[245,8,307,78],[245,8,307,78],[245,5,310,79],[245,6,311,80],[245,6,311,80],[246,8,311,82]]};

  /* Transparent-pixel bounds of the fast side-swim GIFs in their native
     860 × 240 canvas. These let wrap detection use the visible fish rather
     than the large transparent DOM box. */
  var FAST_VISIBLE_BOUNDS = {
    blue: [300, 30, 406, 114],
    yellow: [291, 28, 404, 115],
    green: [260, 54, 341, 159]
  };

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function GoldfishSchool(footer) {
    this.footer = footer;
    this.school = footer.querySelector(SCHOOL_SELECTOR);
    this.objects = this.school ? Array.prototype.slice.call(this.school.querySelectorAll('[data-u20-goldfish-object]')) : [];
    this.fishes = [];
    this.state = 'clustered';
    this.nearViewport = false;
    this.rafId = 0;
    this.idleTimer = 0;
    this.lastTime = 0;
    this.observer = null;
    this.prewarmObserver = null;
    this.prewarmScrollArmed = false;
    this.destroyed = false;
    this.visibleResourcesLoaded = false;
    this.resourcesLoaded = false;
    this.pendingScareStrength = 0;
    this.desktop = window.matchMedia(DESKTOP_QUERY).matches;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.school || this.objects.length !== 3) return;

    for (var i = 0; i < this.objects.length; i += 1) {
      var node = this.objects[i];
      var canvas = node.querySelector('.u20-footer-goldfish-orbit-canvas');
      var image = node.querySelector('.u20-footer-goldfish-body');
      var tailImage = node.querySelector('.u20-footer-goldfish-tail');
      var sprite = new Image();
      /* The compact animated WebP set is visually sufficient at the footer's
         rendered desktop size and is roughly one tenth of the old GIF weight. */
      var useMobileWebP = MOBILE_WEBP_SUPPORTED;
      var spriteUrl = canvas ? canvas.getAttribute(
        useMobileWebP ? 'data-u20-orbit-mobile-sheet' : 'data-u20-orbit-sheet'
      ) || canvas.getAttribute('data-u20-orbit-sheet') : '';
      var spriteFallbackUrl = canvas ? canvas.getAttribute('data-u20-orbit-sheet') || '' : '';
      var spriteFrameWidth = useMobileWebP && canvas
        ? parseInt(canvas.getAttribute('data-u20-orbit-mobile-frame-width'), 10) || 320
        : 430;
      var spriteFrameHeight = useMobileWebP && canvas
        ? parseInt(canvas.getAttribute('data-u20-orbit-mobile-frame-height'), 10) || 89
        : 120;
      var originalSource = image ? image.getAttribute(
        useMobileWebP ? 'data-u20-fish-mobile-original' : 'data-u20-fish-original'
      ) || image.getAttribute('data-u20-fish-original') : '';
      var originalFallbackSource = image ? image.getAttribute('data-u20-fish-original') || '' : '';
      var fastSource = image ? image.getAttribute(
        useMobileWebP ? 'data-u20-fish-mobile-fast' : 'data-u20-fish-fast'
      ) || image.getAttribute('data-u20-fish-fast') : '';
      var fastFallbackSource = image ? image.getAttribute('data-u20-fish-fast') || '' : '';

      if (this.desktop) node.style.visibility = 'hidden';

      this.fishes.push({
        node: node,
        key: node.getAttribute('data-u20-goldfish-object') || '',
        image: image,
        tailImage: tailImage,
        canvas: canvas,
        context: canvas ? canvas.getContext('2d') : null,
        sprite: sprite,
        spriteUrl: spriteUrl,
        spriteFallbackUrl: spriteFallbackUrl,
        spriteFallbackAttempted: false,
        spriteFailed: false,
        spriteFrameWidth: spriteFrameWidth,
        spriteFrameHeight: spriteFrameHeight,
        spriteReady: false,
        originalSource: originalSource,
        originalFallbackSource: originalFallbackSource,
        originalFallbackAttempted: false,
        bodyReady: false,
        bodyFailed: false,
        fastSource: fastSource,
        fastFallbackSource: fastFallbackSource,
        fastFallbackAttempted: false,
        fastFailed: false,
        frameCount: canvas ? parseInt(canvas.getAttribute('data-u20-orbit-frames'), 10) || 140 : 140,
        rightFrame: canvas ? parseInt(canvas.getAttribute('data-u20-orbit-right-frame'), 10) || 0 : 0,
        leftFrame: canvas ? parseInt(canvas.getAttribute('data-u20-orbit-left-frame'), 10) || 0 : 0,
        orbitFrame: 0,
        orbitClock: 0,
        mode: 'clustered',
        fastActive: false,
        fastReady: !fastSource,
        fastPreload: null,
        x: 0,
        y: 0,
        vx: 0,
        vy: 0,
        escapeTravelScale: 1,
        directionX: 0,
        directionY: 0,
        delay: i * 0.055,
        age: 0,
        seed: Math.random() * Math.PI * 2,
        turnPhase: Math.random() * Math.PI * 2,
        swimPhase: Math.random() * Math.PI * 2,
        settleSide: 1,
        settleElapsed: 0,
        settleDuration: 0.56,
        settleStartX: 0,
        settleStartY: 0,
        settleTargetX: 0,
        settleTargetY: 0,
        repeatQueued: false,
        repeatLaunchFrame: 0,
        repeatDirection: 1,
        repeatElapsed: 0,
        repeatDuration: 0,
        repeatStartX: 0,
        repeatStartY: 0,
        repeatTargetX: 0,
        repeatTargetY: 0,
        repeatWrap: false,
        repeatWrapEdge: 0,
        repeatTravelDistance: 0,
        repeatWrapped: false,
        orbitAge: 0,
        repeatHoverArmed: false,
        repeatQueueElapsed: 0,
        repeatViewportLeft: 0,
        repeatViewportRight: 0,
        repeatVisibleLeftOffset: 0,
        repeatVisibleRightOffset: 0
      });

      (function (fish) {
        fish.sprite.addEventListener('load', function () {
          fish.spriteReady = true;
          fish.spriteFailed = false;
          this.markSchoolReadyIfPossible();
          if (fish.mode === 'orbit') this.drawOrbitFrame(fish);
          if (fish.mode === 'settling' && fish.settleElapsed >= fish.settleDuration) this.enterOrbit(fish);
        }.bind(this));
        fish.sprite.addEventListener('error', function () {
          if (
            !fish.spriteFallbackAttempted &&
            fish.spriteFallbackUrl &&
            fish.spriteUrl !== fish.spriteFallbackUrl
          ) {
            fish.spriteFallbackAttempted = true;
            fish.spriteFrameWidth = 430;
            fish.spriteFrameHeight = 120;
            fish.sprite.src = fish.spriteFallbackUrl;
            return;
          }
          fish.spriteFailed = true;
          if (fish.mode === 'settling') this.enterOrbit(fish);
        }.bind(this));
      }.bind(this))(this.fishes[this.fishes.length - 1]);
    }

    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onMotionPreferenceChange = this.onMotionPreferenceChange.bind(this);
    this.onPrewarmScroll = this.onPrewarmScroll.bind(this);
    this.tick = this.tick.bind(this);

    this.initialize();
  }

  GoldfishSchool.prototype.stopPrewarmWatch = function () {
    if (this.prewarmObserver) {
      this.prewarmObserver.disconnect();
      this.prewarmObserver = null;
    }
    if (this.prewarmScrollArmed) {
      window.removeEventListener('scroll', this.onPrewarmScroll);
      this.prewarmScrollArmed = false;
    }
  };

  GoldfishSchool.prototype.prewarmVisibleResources = function () {
    if (
      this.visibleResourcesLoaded ||
      this.destroyed ||
      (this.motionQuery.matches && !this.desktop)
    ) return;
    this.visibleResourcesLoaded = true;
    this.stopPrewarmWatch();
    for (var i = 0; i < this.fishes.length; i += 1) {
      var fish = this.fishes[i];
      if (!fish.originalSource) continue;

      if (fish.image) {
        (function (targetFish) {
          var markLoaded = function () {
            if (targetFish.bodyReady || this.destroyed) return;
            targetFish.bodyReady = true;
            targetFish.bodyFailed = false;
            if (this.desktop) targetFish.node.style.visibility = 'visible';
            if (targetFish.tailImage) {
              targetFish.tailImage.loading = 'eager';
              targetFish.tailImage.src = targetFish.image.currentSrc || targetFish.image.src || targetFish.originalSource;
            }
            this.markSchoolReadyIfPossible();
          }.bind(this);
          var useFallback = function () {
            if (
              !targetFish.originalFallbackAttempted &&
              targetFish.originalFallbackSource &&
              targetFish.originalSource !== targetFish.originalFallbackSource
            ) {
              targetFish.originalFallbackAttempted = true;
              targetFish.originalSource = targetFish.originalFallbackSource;
              targetFish.image.src = targetFish.originalFallbackSource;
              return;
            }
            targetFish.bodyFailed = true;
            if (this.desktop) targetFish.node.style.visibility = 'hidden';
            this.markSchoolReadyIfPossible();
          }.bind(this);

          targetFish.image.loading = 'eager';
          targetFish.image.fetchPriority = 'high';
          targetFish.image.addEventListener('load', markLoaded, {once: true});
          targetFish.image.addEventListener('error', useFallback);
          targetFish.image.src = targetFish.originalSource;
          if (targetFish.image.complete) {
            if (targetFish.image.naturalWidth > 0) markLoaded();
            else useFallback();
          }
        }.bind(this))(fish);
      }
    }
  };

  GoldfishSchool.prototype.markSchoolReadyIfPossible = function () {
    if (!this.school || this.destroyed) return;
    var ready = this.fishes.some(function (fish) {
      return fish.bodyReady || (!fish.image && !fish.bodyFailed);
    });
    if (ready) this.school.dataset.u20FishReady = 'true';
  };

  GoldfishSchool.prototype.armMobilePrewarm = function () {
    if (this.destroyed || this.visibleResourcesLoaded || this.prewarmObserver || this.motionQuery.matches) return;
    if (typeof window.IntersectionObserver !== 'function') {
      this.prewarmVisibleResources();
      return;
    }
    var distance = Math.min(
      MOBILE_PREWARM_MAX_DISTANCE,
      Math.max(MOBILE_PREWARM_MIN_DISTANCE, Math.round(window.innerHeight * MOBILE_PREWARM_VIEWPORTS))
    );
    var self = this;
    this.prewarmObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === self.footer && entry.isIntersecting) self.prewarmVisibleResources();
      });
    }, {root: null, rootMargin: distance + 'px 0px ' + distance + 'px 0px', threshold: 0});
    this.prewarmObserver.observe(this.footer);
  };

  GoldfishSchool.prototype.armDesktopPrewarm = function () {
    if (this.destroyed || this.visibleResourcesLoaded || this.prewarmObserver) return;
    if (typeof window.IntersectionObserver !== 'function') {
      this.prewarmVisibleResources();
      return;
    }
    var distance = Math.min(
      DESKTOP_PREWARM_MAX_DISTANCE,
      Math.max(DESKTOP_PREWARM_MIN_DISTANCE, Math.round(window.innerHeight * DESKTOP_PREWARM_VIEWPORTS))
    );
    var self = this;
    this.prewarmObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === self.footer && entry.isIntersecting) self.prewarmVisibleResources();
      });
    }, {root: null, rootMargin: distance + 'px 0px ' + distance + 'px 0px', threshold: 0});
    this.prewarmObserver.observe(this.footer);
  };

  GoldfishSchool.prototype.onPrewarmScroll = function () {
    if (this.destroyed || (window.scrollY || window.pageYOffset || 0) <= 0) return;
    window.removeEventListener('scroll', this.onPrewarmScroll);
    this.prewarmScrollArmed = false;
    this.armMobilePrewarm();
  };

  GoldfishSchool.prototype.loadResources = function () {
    if (this.resourcesLoaded || this.destroyed) return;
    this.resourcesLoaded = true;
    this.prewarmVisibleResources();

    for (var i = 0; i < this.fishes.length; i += 1) {
      (function (fish) {
        if (fish.spriteUrl && !fish.spriteReady && !fish.spriteFailed) fish.sprite.src = fish.spriteUrl;

        if (!fish.fastSource) {
          fish.fastReady = true;
          return;
        }

        var preloader = new Image();
        fish.fastPreload = preloader;
        var markReady = function () {
          if (fish.fastReady || this.destroyed) return;
          fish.fastReady = true;
          fish.fastFailed = false;
          /* Cold-cache loads must never delay the interaction. If the fish has
             already started escaping with its original GIF, switch to the fast
             asset as soon as it becomes available without restarting motion. */
          if ((fish.mode === 'escape' || fish.mode === 'settling' || fish.mode === 'repeat-escape') && !fish.fastActive) {
            this.setFastSwim(fish, true);
          }
          this.flushPendingScare();
        }.bind(this);
        var handleError = function () {
          if (
            !fish.fastFallbackAttempted &&
            fish.fastFallbackSource &&
            fish.fastSource !== fish.fastFallbackSource
          ) {
            fish.fastFallbackAttempted = true;
            fish.fastSource = fish.fastFallbackSource;
            preloader.src = fish.fastFallbackSource;
            return;
          }
          fish.fastFailed = true;
          fish.fastReady = true;
          this.flushPendingScare();
        }.bind(this);
        preloader.addEventListener('load', markReady, {once: true});
        preloader.addEventListener('error', handleError);
        preloader.src = fish.fastSource;
        if (typeof preloader.decode === 'function') {
          preloader.decode().then(markReady).catch(function () {});
        }
      }.bind(this))(this.fishes[i]);
    }
  };

  GoldfishSchool.prototype.initialize = function () {
    this.reset();
    this.footer.addEventListener('pointermove', this.onPointerMove, {passive: true});
    this.footer.addEventListener('pointerdown', this.onPointerDown, {passive: true});
    window.addEventListener('resize', this.onResize, {passive: true});
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    if (typeof this.motionQuery.addEventListener === 'function') {
      this.motionQuery.addEventListener('change', this.onMotionPreferenceChange);
    } else {
      this.motionQuery.addListener(this.onMotionPreferenceChange);
    }

    if (window.matchMedia(MOBILE_QUERY).matches && !this.motionQuery.matches) {
      this.prewarmScrollArmed = true;
      window.addEventListener('scroll', this.onPrewarmScroll, {passive: true});
    }
    if (window.matchMedia(DESKTOP_QUERY).matches) {
      this.armDesktopPrewarm();
    }

    var self = this;
    if (typeof window.IntersectionObserver !== 'function') {
      this.nearViewport = true;
      this.syncAnimationState();
      return;
    }

    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== self.footer) return;
        if (entry.isIntersecting) {
          self.nearViewport = true;
          self.syncAnimationState();
          return;
        }

        var rect = self.footer.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
          self.nearViewport = false;
          self.syncAnimationState();
          self.reset();
        }
      });
    }, {root: null, rootMargin: '600px 0px 600px 0px', threshold: 0});

    this.observer.observe(this.footer);
  };

  GoldfishSchool.prototype.canAnimate = function () {
    return !this.destroyed &&
      this.nearViewport &&
      !document.hidden &&
      !this.motionQuery.matches;
  };

  GoldfishSchool.prototype.stopTick = function () {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.idleTimer) window.clearTimeout(this.idleTimer);
    this.rafId = 0;
    this.idleTimer = 0;
    this.lastTime = 0;
  };

  GoldfishSchool.prototype.syncAnimationState = function () {
    var active = this.canAnimate();
    if (this.school) this.school.dataset.u20FishActive = active ? 'true' : 'false';
    if (!active) {
      this.stopTick();
      return;
    }
    this.loadResources();
    this.requestTick();
  };

  GoldfishSchool.prototype.onVisibilityChange = function () {
    this.syncAnimationState();
  };

  GoldfishSchool.prototype.onMotionPreferenceChange = function () {
    this.syncAnimationState();
  };

  GoldfishSchool.prototype.getVisualCluster = function () {
    var schoolRect = this.school.getBoundingClientRect();
    return {
      x: schoolRect.left + schoolRect.width * 0.5,
      y: schoolRect.top + schoolRect.height * 0.5,
      radius: clamp(Math.min(schoolRect.width, schoolRect.height) * 0.28, 90, 240)
    };
  };

  GoldfishSchool.prototype.onPointerMove = function (event) {
    if (!this.canAnimate()) return;
    if (this.state === 'clustered') {
      var cluster = this.getVisualCluster();
      var dx = event.clientX - cluster.x;
      var dy = event.clientY - cluster.y;
      if ((dx * dx) + (dy * dy) <= cluster.radius * cluster.radius) this.scare(1);
      return;
    }

    /* Once a fish has settled into its own orbit, it becomes hover-reactive
       after a short 0.8 s breathing period. The pointer must first be outside
       the fish's live frame bounds before re-entry can trigger another escape;
       this prevents an immediate chain reaction while the pointer is still
       resting on the landing spot. */
    for (var i = this.fishes.length - 1; i >= 0; i -= 1) {
      var fish = this.fishes[i];
      if (fish.mode !== 'orbit' || fish.repeatQueued || fish.orbitAge < 0.8) continue;
      var inside = this.hitTestOrbitFish(fish, event.clientX, event.clientY);
      if (!inside) {
        fish.repeatHoverArmed = true;
        continue;
      }
      if (fish.repeatHoverArmed) {
        fish.repeatHoverArmed = false;
      fish.repeatQueueElapsed = 0;
        this.queueRepeatEscape(fish);
        return;
      }
    }
  };

  GoldfishSchool.prototype.onPointerDown = function (event) {
    if (!this.canAnimate()) return;
    var coarsePointer = window.matchMedia('(pointer: coarse)').matches;
    if (this.state === 'clustered') {
      var cluster = this.getVisualCluster();
      var dx = event.clientX - cluster.x;
      var dy = event.clientY - cluster.y;
      if ((dx * dx) + (dy * dy) <= Math.pow(cluster.radius * 1.12, 2)) {
        this.scare(coarsePointer ? 0.72 : 1);
      }
      return;
    }

    /* Touch screens have no reliable hover re-entry. Once a fish has rested
       in orbit for the same 0.8 s breathing period used by desktop hover,
       tapping its live frame starts the existing repeat-escape path. */
    if (!coarsePointer) return;
    for (var i = this.fishes.length - 1; i >= 0; i -= 1) {
      var fish = this.fishes[i];
      if (fish.mode !== 'orbit' || fish.repeatQueued || fish.orbitAge < 0.8) continue;
      if (!this.hitTestOrbitFish(fish, event.clientX, event.clientY)) continue;
      this.queueRepeatEscape(fish);
      return;
    }
  };

  GoldfishSchool.prototype.hitTestOrbitFish = function (fish, clientX, clientY) {
    if (!fish.canvas) return false;
    var rect = fish.canvas.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    var frame = ((Math.floor(fish.orbitFrame) % fish.frameCount) + fish.frameCount) % fish.frameCount;
    var frames = ORBIT_HIT_BOUNDS[fish.key];
    var bounds = frames && frames[frame];
    if (!bounds) return false;

    /* The hit box comes from the transparent-pixel bounds of the exact current
       spritesheet frame. This avoids getImageData(), which can fail when the
       Shopify asset CDN taints the canvas, and follows the moving fish instead
       of using one fixed box in the canvas centre. */
    var localX = (clientX - rect.left) * (fish.canvas.width / rect.width);
    var localY = (clientY - rect.top) * (fish.canvas.height / rect.height);
    return localX >= bounds[0] && localX <= bounds[2] && localY >= bounds[1] && localY <= bounds[3];
  };

  GoldfishSchool.prototype.forwardFrameDistance = function (fromFrame, toFrame, frameCount) {
    return ((toFrame - fromFrame) % frameCount + frameCount) % frameCount;
  };

  GoldfishSchool.prototype.circularFrameDistance = function (fromFrame, toFrame, frameCount) {
    var forward = this.forwardFrameDistance(fromFrame, toFrame, frameCount);
    return Math.min(forward, frameCount - forward);
  };

  GoldfishSchool.prototype.getVisibleFishGeometry = function (fish) {
    var nodeRect = fish.node.getBoundingClientRect();
    var nativeBounds = FAST_VISIBLE_BOUNDS[fish.key] || FAST_VISIBLE_BOUNDS.blue;
    var scale = nodeRect.width / 860;
    var pivotPercent = fish.key === 'green' ? 0.35 : 0.405;
    var pivot = nodeRect.width * pivotPercent;
    var facing = fish.directionX < 0 ? -1 : 1;
    var leftLocal;
    var rightLocal;

    if (facing > 0) {
      leftLocal = nativeBounds[0] * scale;
      rightLocal = nativeBounds[2] * scale;
    } else {
      leftLocal = (2 * pivot) - (nativeBounds[2] * scale);
      rightLocal = (2 * pivot) - (nativeBounds[0] * scale);
    }

    return {
      nodeRect: nodeRect,
      visibleLeft: nodeRect.left + leftLocal,
      visibleRight: nodeRect.left + rightLocal,
      visibleLeftOffset: leftLocal - (nodeRect.width * 0.5),
      visibleRightOffset: rightLocal - (nodeRect.width * 0.5)
    };
  };

  GoldfishSchool.prototype.getViewportLocalEdges = function () {
    var schoolRect = this.school.getBoundingClientRect();
    var centerX = schoolRect.left + (schoolRect.width * 0.5);
    return {
      left: Math.max(0, schoolRect.left) - centerX,
      right: Math.min(window.innerWidth, schoolRect.right) - centerX
    };
  };

  GoldfishSchool.prototype.queueRepeatEscape = function (fish) {
    if (fish.mode !== 'orbit' || fish.repeatQueued) return;
    var currentFrame = ((Math.round(fish.orbitFrame) % fish.frameCount) + fish.frameCount) % fish.frameCount;
    var toRight = this.circularFrameDistance(currentFrame, fish.rightFrame, fish.frameCount);
    var toLeft = this.circularFrameDistance(currentFrame, fish.leftFrame, fish.frameCount);

    /* Choose the side pose nearest to the pointer-entry moment. Do not wait
       for a full orbit to reach a future pose: the queue has a strict 160 ms
       upper limit in updateOrbit(). */
    fish.repeatDirection = toRight <= toLeft ? 1 : -1;
    fish.repeatLaunchFrame = fish.repeatDirection > 0 ? fish.rightFrame : fish.leftFrame;
    fish.repeatQueued = true;
    fish.repeatQueueElapsed = 0;
    fish.node.dataset.u20FishRepeatQueued = 'true';
    this.requestTick();
  };

  GoldfishSchool.prototype.startRepeatEscape = function (fish) {
    if (!fish.repeatQueued || fish.mode !== 'orbit') return;
    var direction = fish.repeatDirection >= 0 ? 1 : -1;
    var viewport = this.getViewportLocalEdges();
    fish.directionX = direction;
    fish.directionY = 0;
    fish.node.style.setProperty('--u20-fish-facing', direction > 0 ? '1' : '-1');
    fish.node.style.setProperty('--u20-fish-angle', '0deg');

    var geometry = this.getVisibleFishGeometry(fish);
    var schoolRect = this.school.getBoundingClientRect();
    var centerX = schoolRect.left + (schoolRect.width * 0.5);
    var visibleLeftLocal = geometry.visibleLeft - centerX;
    var visibleRightLocal = geometry.visibleRight - centerX;
    var forwardSpace = direction > 0
      ? viewport.right - visibleRightLocal
      : visibleLeftLocal - viewport.left;
    var comfortableRun = clamp(schoolRect.width * randomBetween(0.26, 0.36), 300, 620);
    var shouldWrap = forwardSpace < comfortableRun * 0.72;
    var targetX;
    var travelDistance;

    fish.repeatViewportLeft = viewport.left;
    fish.repeatViewportRight = viewport.right;
    fish.repeatVisibleLeftOffset = visibleLeftLocal - fish.x;
    fish.repeatVisibleRightOffset = visibleRightLocal - fish.x;

    if (shouldWrap) {
      var viewportWidth = Math.max(1, viewport.right - viewport.left);
      var landingRatio = randomBetween(0.36, 0.60);
      targetX = direction > 0
        ? viewport.left + viewportWidth * landingRatio
        : viewport.right - viewportWidth * landingRatio;

      /* Split a wrapped journey into two explicit pieces:
         1) current position -> fully outside the forward viewport edge
         2) fully outside the opposite edge -> new landing point
         Keeping these distances separately prevents the following frame from
         recomputing the fish from its original start position and flashing it
         back into the middle of the footer. */
      var exitDistance = direction > 0
        ? Math.max(0, viewport.right - visibleLeftLocal)
        : Math.max(0, visibleRightLocal - viewport.left);
      var entryStartX = direction > 0
        ? viewport.left - fish.repeatVisibleRightOffset
        : viewport.right - fish.repeatVisibleLeftOffset;
      var entryDistance = Math.abs(targetX - entryStartX);
      travelDistance = exitDistance + entryDistance;
      fish.repeatExitDistance = exitDistance;
      fish.repeatEntryStartX = entryStartX;
      fish.repeatEntryDistance = entryDistance;
    } else {
      fish.repeatExitDistance = 0;
      fish.repeatEntryStartX = 0;
      fish.repeatEntryDistance = 0;
      travelDistance = clamp(forwardSpace * randomBetween(0.56, 0.74), 210, comfortableRun);
      targetX = fish.x + direction * travelDistance;
    }

    fish.repeatQueued = false;
    fish.repeatQueueElapsed = 0;
    fish.node.dataset.u20FishRepeatQueued = 'false';
    fish.mode = 'repeat-escape';
    fish.node.dataset.u20FishMode = 'escape';
    fish.repeatElapsed = 0;
    fish.repeatDuration = clamp(travelDistance / randomBetween(315, 380), 0.72, 2.0);
    fish.repeatStartX = fish.x;
    fish.repeatStartY = fish.y;
    fish.repeatTargetX = targetX;
    fish.repeatTargetY = clamp(fish.y + randomBetween(-22, 16), -this.getBounds().y * 0.76, this.getBounds().y * 0.76);
    fish.repeatWrap = shouldWrap;
    fish.repeatTravelDistance = travelDistance;
    fish.repeatWrapped = false;
    fish.vx = direction * (travelDistance / Math.max(fish.repeatDuration, 0.001));
    fish.vy = (fish.repeatTargetY - fish.repeatStartY) / Math.max(fish.repeatDuration, 0.001);
    fish.age = 0;
    fish.settleSide = direction;
    fish.swimPhase = fish.seed;
    fish.node.style.setProperty('--u20-orbit-offset-x', '0px');
    fish.node.style.setProperty('--u20-orbit-offset-y', '0px');
    if (fish.fastReady) this.setFastSwim(fish, true);
  };

  GoldfishSchool.prototype.updateRepeatEscape = function (fish, delta) {
    fish.repeatElapsed += delta;
    var progress = clamp(fish.repeatElapsed / Math.max(fish.repeatDuration, 0.001), 0, 1);
    /* Fast departure, then a long natural deceleration into the new orbit. */
    var eased = 1 - Math.pow(1 - progress, 2.35);
    var direction = fish.repeatDirection >= 0 ? 1 : -1;
    var rawDistance = fish.repeatTravelDistance * eased;
    var rawX;
    var previousX = fish.x;
    var previousY = fish.y;

    if (fish.repeatWrap) {
      var exitDistance = Math.max(0, fish.repeatExitDistance || 0);
      if (rawDistance < exitDistance) {
        /* Departure segment: continue from the current orbit position until
           the entire visible fish is outside the forward screen edge. */
        rawX = fish.repeatStartX + direction * rawDistance;
        fish.repeatWrapped = false;
      } else {
        /* Re-entry segment: start wholly outside the opposite real viewport
           edge and advance continuously toward the new landing point. */
        var entryDistanceTravelled = rawDistance - exitDistance;
        rawX = fish.repeatEntryStartX + direction * entryDistanceTravelled;
        fish.repeatWrapped = true;
      }
    } else {
      rawX = fish.repeatStartX + direction * rawDistance;
    }

    fish.x = rawX;
    fish.y = fish.repeatStartY + ((fish.repeatTargetY - fish.repeatStartY) * eased);
    var safeDelta = Math.max(delta, 1 / 240);
    var dx = fish.x - previousX;
    /* Ignore the artificial full-screen wrap jump when deriving velocity. */
    if (fish.repeatWrap && Math.abs(dx) > (fish.repeatViewportRight - fish.repeatViewportLeft) * 0.65) dx = direction * Math.max(1, fish.repeatTravelDistance * (1 - progress) * 0.02);
    fish.vx = dx / safeDelta;
    fish.vy = (fish.y - previousY) / safeDelta;
    fish.swimPhase += delta * (9.5 + ((1 - progress) * 5.5));

    if (progress >= 1) {
      fish.x = fish.repeatTargetX;
      fish.y = fish.repeatTargetY;
      fish.settleSide = direction;
      this.enterOrbit(fish);
    }
  };

  GoldfishSchool.prototype.setFastSwim = function (fish, active) {
    if (!fish.image || fish.fastActive === active) return;
    if (active && (fish.fastFailed || !fish.fastReady || !fish.fastSource)) return;
    fish.fastActive = active;
    if (!this.resourcesLoaded) return;
    var source = active ? fish.fastSource : fish.originalSource;
    if (source) {
      fish.image.src = source;
      if (fish.tailImage) fish.tailImage.src = source;
    }
  };

  GoldfishSchool.prototype.areFastAssetsReady = function () {
    for (var i = 0; i < this.fishes.length; i += 1) {
      if (!this.fishes[i].fastReady) return false;
    }
    return true;
  };

  GoldfishSchool.prototype.flushPendingScare = function () {
    if (!this.pendingScareStrength || this.state !== 'clustered' || !this.areFastAssetsReady()) return;
    var strength = this.pendingScareStrength;
    this.pendingScareStrength = 0;
    this.scare(strength);
  };

  GoldfishSchool.prototype.scare = function (strength) {
    if (this.state !== 'clustered' || !this.canAnimate()) return;
    /* Start the physical scatter immediately, even on the first uncached page
       load. The fast GIF is a visual enhancement and must never be a gate for
       the interaction itself. */
    this.pendingScareStrength = 0;
    this.state = 'scattered';
    this.school.dataset.u20FishState = 'scattered';

    var majoritySign = Math.random() < 0.5 ? -1 : 1;
    var oppositeIndex = Math.floor(Math.random() * this.fishes.length);
    var escapeBounds = this.getBounds();
    var escapeTravelScale = this.getEscapeTravelScale(escapeBounds);

    for (var i = 0; i < this.fishes.length; i += 1) {
      var fish = this.fishes[i];
      var horizontalSign = i === oppositeIndex ? -majoritySign : majoritySign;
      var verticalBias = randomBetween(-0.18, 0.12);
      var length = Math.sqrt(1 + (verticalBias * verticalBias));
      var dx = horizontalSign / length;
      var dy = verticalBias / length;
      var speed = randomBetween(300, 390) * strength * escapeTravelScale;

      fish.mode = 'escape';
      fish.node.dataset.u20FishMode = 'escape';
      fish.directionX = dx;
      fish.directionY = dy;
      fish.vx = dx * speed;
      fish.vy = dy * speed;
      fish.escapeTravelScale = escapeTravelScale;
      fish.age = -fish.delay;
      fish.orbitClock = 0;
      fish.settleElapsed = 0;
      fish.settleDuration = randomBetween(0.48, 0.64);
      fish.node.style.setProperty('--u20-fish-facing', horizontalSign > 0 ? '1' : '-1');
      fish.node.style.setProperty('--u20-fish-angle', (horizontalSign * Math.atan2(dy, Math.abs(dx)) * 180 / Math.PI).toFixed(2) + 'deg');
      if (fish.fastReady) this.setFastSwim(fish, true);
    }
    this.requestTick();
  };

  GoldfishSchool.prototype.getBounds = function () {
    var rect = this.school.getBoundingClientRect();
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    return {
      x: Math.max(90, rect.width * (mobile ? 0.30 : 0.36)),
      y: Math.max(50, rect.height * (mobile ? 0.22 : 0.30))
    };
  };

  GoldfishSchool.prototype.getEscapeTravelScale = function (bounds) {
    if (window.matchMedia('(max-width: 749px)').matches) return 1;
    var horizontalBound = bounds && Number.isFinite(bounds.x)
      ? bounds.x
      : this.getBounds().x;

    return clamp(
      horizontalBound / DESKTOP_REFERENCE_ESCAPE_BOUND,
      0.90,
      1.65
    );
  };

  GoldfishSchool.prototype.updateClustered = function (timeSeconds) {
    for (var i = 0; i < this.fishes.length; i += 1) {
      var fish = this.fishes[i];
      fish.x = Math.sin(timeSeconds * (0.45 + i * 0.06) + fish.seed) * (2.5 + i * 0.7);
      fish.y = Math.cos(timeSeconds * (0.52 + i * 0.05) + fish.seed) * (2.0 + i * 0.5);
      fish.vx = 0;
      fish.vy = 0;
    }
  };

  GoldfishSchool.prototype.drawOrbitFrame = function (fish) {
    if (!fish.canvas || !fish.context || !fish.spriteReady) return;
    var cols = 10;
    var sourceFrameWidth = fish.spriteFrameWidth || 430;
    var sourceFrameHeight = fish.spriteFrameHeight || 120;
    var outputFrameWidth = 430;
    var outputFrameHeight = 120;
    var frame = ((Math.floor(fish.orbitFrame) % fish.frameCount) + fish.frameCount) % fish.frameCount;
    var sx = (frame % cols) * sourceFrameWidth;
    var sy = Math.floor(frame / cols) * sourceFrameHeight;
    fish.context.clearRect(0, 0, outputFrameWidth, outputFrameHeight);
    fish.context.drawImage(
      fish.sprite,
      sx,
      sy,
      sourceFrameWidth,
      sourceFrameHeight,
      0,
      0,
      outputFrameWidth,
      outputFrameHeight
    );
  };

  GoldfishSchool.prototype.beginSettle = function (fish, bounds) {
    if (fish.mode === 'settling' || fish.mode === 'orbit') return;

    fish.mode = 'settling';
    fish.node.dataset.u20FishMode = 'settling';
    fish.settleSide = fish.vx >= 0 ? 1 : -1;
    fish.settleElapsed = 0;
    fish.settleDuration = randomBetween(0.48, 0.64);
    fish.settleStartX = fish.x;
    fish.settleStartY = fish.y;

    /* Keep the final stop safely inside the visible activity area. The fish
       no longer asymptotically crawls toward an unreachable threshold: once
       settling starts, it is guaranteed to arrive here in a fixed duration. */
    var edgeInset = clamp(bounds.x * 0.055, 18, 28);
    fish.settleTargetX = fish.settleSide * (bounds.x - edgeInset);
    fish.settleTargetY = clamp(
      fish.y + randomBetween(-10, 10),
      -bounds.y * 0.78,
      bounds.y * 0.78
    );
  };

  GoldfishSchool.prototype.updateSettling = function (fish, delta) {
    fish.settleElapsed += delta;
    var progress = clamp(fish.settleElapsed / Math.max(fish.settleDuration, 0.001), 0, 1);
    var eased = progress * progress * (3 - (2 * progress));

    var previousX = fish.x;
    var previousY = fish.y;
    fish.x = fish.settleStartX + ((fish.settleTargetX - fish.settleStartX) * eased);
    fish.y = fish.settleStartY + ((fish.settleTargetY - fish.settleStartY) * eased);

    var safeDelta = Math.max(delta, 1 / 240);
    fish.vx = (fish.x - previousX) / safeDelta;
    fish.vy = (fish.y - previousY) / safeDelta;
    fish.swimPhase += delta * (6.4 + ((1 - progress) * 5.2));

    if (progress >= 1) {
      fish.x = fish.settleTargetX;
      fish.y = fish.settleTargetY;
      this.enterOrbit(fish);
    }
  };

  GoldfishSchool.prototype.getOrbitAnchorOffset = function (fish) {
    var offsets = {
      blue: {
        right: {x: -3.5, y: 1.0},
        left: {x: -27.5, y: -43.0}
      },
      yellow: {
        right: {x: -23.75, y: 8.75},
        left: {x: -27.25, y: -47.75}
      },
      green: {
        right: {x: -41.75, y: 20.25},
        left: {x: -119.75, y: -17.75}
      }
    };
    var fishOffsets = offsets[fish.key] || offsets.blue;
    return fish.settleSide > 0 ? fishOffsets.right : fishOffsets.left;
  };

  GoldfishSchool.prototype.enterOrbit = function (fish) {
    if (fish.mode === 'orbit') return;
    if (!fish.spriteReady) {
      if (fish.spriteFailed) {
        fish.mode = 'settled';
        fish.node.dataset.u20FishMode = 'settling';
        fish.vx = 0;
        fish.vy = 0;
        this.setFastSwim(fish, false);
      }
      return;
    }
    fish.mode = 'orbit';
    fish.node.dataset.u20FishMode = 'orbit';
    if (!fish.settleSide) fish.settleSide = fish.vx >= 0 ? 1 : -1;
    fish.orbitFrame = fish.settleSide > 0 ? fish.rightFrame : fish.leftFrame;
    var anchorOffset = this.getOrbitAnchorOffset(fish);
    fish.node.style.setProperty('--u20-orbit-offset-x', anchorOffset.x.toFixed(2) + 'px');
    fish.node.style.setProperty('--u20-orbit-offset-y', anchorOffset.y.toFixed(2) + 'px');
    fish.orbitClock = 0;
    fish.orbitAge = 0;
    fish.repeatHoverArmed = false;
    fish.vx = 0;
    fish.vy = 0;
    this.setFastSwim(fish, false);
    fish.node.style.setProperty('--u20-fish-angle', '0deg');
    fish.node.style.setProperty('--u20-fish-facing', '1');
    fish.node.style.setProperty('--u20-fish-tail-angle', '0deg');
    fish.node.style.setProperty('--u20-fish-body-skew', '0deg');
    fish.node.style.setProperty('--u20-fish-body-roll', '0deg');
    fish.node.style.setProperty('--u20-fish-body-scale', '1');
    this.drawOrbitFrame(fish);
  };

  GoldfishSchool.prototype.updateOrbit = function (fish, delta) {
    fish.orbitAge += delta;
    if (fish.repeatQueued) fish.repeatQueueElapsed += delta;
    fish.orbitClock += delta;
    while (fish.orbitClock >= 0.10) {
      fish.orbitClock -= 0.10;
      fish.orbitFrame = (fish.orbitFrame + 1) % fish.frameCount;
      this.drawOrbitFrame(fish);
      if (fish.repeatQueued && Math.round(fish.orbitFrame) === fish.repeatLaunchFrame) {
        this.startRepeatEscape(fish);
        break;
      }
    }
    /* The ideal side pose is only a visual preference. It must never block the
       interaction for multiple seconds. */
    if (fish.repeatQueued && fish.repeatQueueElapsed >= 0.16) this.startRepeatEscape(fish);
  };

  GoldfishSchool.prototype.updateScattered = function (delta, timeSeconds) {
    var bounds = this.getBounds();
    var mobile = window.matchMedia('(pointer: coarse)').matches;

    for (var i = 0; i < this.fishes.length; i += 1) {
      var fish = this.fishes[i];
      if (fish.mode === 'orbit') {
        this.updateOrbit(fish, delta);
        continue;
      }
      if (fish.mode === 'repeat-escape') {
        this.updateRepeatEscape(fish, delta);
        continue;
      }
      if (fish.mode === 'settling') {
        this.updateSettling(fish, delta);
        continue;
      }
      if (fish.mode === 'settled') continue;

      fish.age += delta;
      if (fish.age < 0) continue;

      var currentSpeed = Math.sqrt((fish.vx * fish.vx) + (fish.vy * fish.vy));
      var burstAmount = clamp(1 - (fish.age / 0.82), 0, 1);
      var swimFrequency = 8.2 + (currentSpeed / 390) * 3.4 + burstAmount * 4.8;
      fish.swimPhase += delta * swimFrequency;

      var distanceToSide = fish.vx >= 0 ? (bounds.x - fish.x) : (fish.x + bounds.x);
      var decelZone = clamp(70 + currentSpeed * 0.18, 82, 145);
      var approachingSide = distanceToSide < decelZone;

      if (fish.age > 0.55 && !approachingSide) {
        var wander = mobile ? 18 : 30;
        fish.turnPhase += delta * randomBetween(0.75, 1.12);
        fish.vx += Math.sin(timeSeconds * 0.68 + fish.seed + fish.turnPhase) * wander * delta;
        fish.vy += Math.cos(timeSeconds * 0.57 + fish.seed * 1.37 - fish.turnPhase) * wander * 0.72 * delta;
        var drag = Math.pow(0.987, delta * 60);
        fish.vx *= drag;
        fish.vy *= drag;
      }

      /* V45.8.305 — lifecycle guarantee for unusually wide desktops or a
         mid-flight resize. First escape is never allowed to remain forever in
         a near-zero-velocity state. Normal screens still reach approachingSide
         first, so their historical timing is unchanged. */
      var stalledWideEscape =
        fish.age > 1.55 &&
        currentSpeed < 72;
      var absoluteEscapeDeadline = fish.age > 2.25;

      if (
        (approachingSide && fish.age > 0.34) ||
        stalledWideEscape ||
        absoluteEscapeDeadline
      ) {
        this.beginSettle(fish, bounds);
        this.updateSettling(fish, delta);
        continue;
      }

      fish.x += fish.vx * delta;
      fish.y += fish.vy * delta;
      fish.y = clamp(fish.y, -bounds.y, bounds.y);

      /* Emergency guard for unusually large frame deltas: still enter the
         deterministic settle path rather than bounce or disappear. */
      if (Math.abs(fish.x) >= bounds.x - 2) {
        fish.x = clamp(fish.x, -bounds.x + 2, bounds.x - 2);
        this.beginSettle(fish, bounds);
      }
    }
  };

  GoldfishSchool.prototype.render = function () {
    for (var i = 0; i < this.fishes.length; i += 1) {
      var fish = this.fishes[i];
      fish.node.style.setProperty('--u20-fish-x', fish.x.toFixed(2) + 'px');
      fish.node.style.setProperty('--u20-fish-y', fish.y.toFixed(2) + 'px');

      if ((fish.mode === 'escape' || fish.mode === 'settling' || fish.mode === 'repeat-escape') && (Math.abs(fish.vx) + Math.abs(fish.vy)) > 0.1) {
        var facing = fish.vx >= 0 ? 1 : -1;
        var localPitch = facing * Math.atan2(fish.vy, Math.max(Math.abs(fish.vx), 0.001)) * 180 / Math.PI;
        fish.node.style.setProperty('--u20-fish-facing', facing > 0 ? '1' : '-1');
        fish.node.style.setProperty('--u20-fish-angle', localPitch.toFixed(2) + 'deg');
        var burstAmount = clamp(1 - (Math.max(fish.age, 0) / 0.82), 0, 1);
        var tailAmplitude = 7.5 + burstAmount * 7.5;
        var bodyAmplitude = 1.6 + burstAmount * 1.7;
        var tailAngle = Math.sin(fish.swimPhase) * tailAmplitude;
        var bodySkew = Math.sin(fish.swimPhase - 0.62) * bodyAmplitude;
        var bodyRoll = Math.sin((fish.swimPhase * 0.5) + fish.seed) * (0.55 + burstAmount * 0.45);
        var bodyScale = 1 + Math.sin(fish.swimPhase * 2) * (0.012 + burstAmount * 0.014);
        fish.node.style.setProperty('--u20-fish-tail-angle', tailAngle.toFixed(2) + 'deg');
        fish.node.style.setProperty('--u20-fish-body-skew', bodySkew.toFixed(2) + 'deg');
        fish.node.style.setProperty('--u20-fish-body-roll', bodyRoll.toFixed(2) + 'deg');
        fish.node.style.setProperty('--u20-fish-body-scale', bodyScale.toFixed(4));
      } else if (fish.mode !== 'orbit') {
        fish.node.style.setProperty('--u20-fish-angle', '0deg');
        fish.node.style.setProperty('--u20-fish-facing', '1');
        fish.node.style.setProperty('--u20-fish-tail-angle', '0deg');
        fish.node.style.setProperty('--u20-fish-body-skew', '0deg');
        fish.node.style.setProperty('--u20-fish-body-roll', '0deg');
        fish.node.style.setProperty('--u20-fish-body-scale', '1');
      }
    }
  };

  GoldfishSchool.prototype.tick = function (time) {
    this.rafId = 0;
    if (!this.canAnimate()) return;
    if (!this.lastTime) this.lastTime = time;
    var delta = clamp((time - this.lastTime) / 1000, 1 / 240, 1 / 30);
    this.lastTime = time;
    var seconds = time / 1000;

    if (this.state === 'clustered') this.updateClustered(seconds);
    else this.updateScattered(delta, seconds);

    this.render();
    this.requestTick();
  };

  GoldfishSchool.prototype.requestTick = function () {
    if (!this.canAnimate() || this.rafId) return;
    if (this.state === 'clustered') {
      if (this.idleTimer) return;
      this.idleTimer = window.setTimeout(function () {
        this.idleTimer = 0;
        if (!this.canAnimate() || this.rafId) return;
        this.rafId = requestAnimationFrame(this.tick);
      }.bind(this), CLUSTERED_FRAME_INTERVAL);
      return;
    }
    if (this.idleTimer) {
      window.clearTimeout(this.idleTimer);
      this.idleTimer = 0;
    }
    this.rafId = requestAnimationFrame(this.tick);
  };

  GoldfishSchool.prototype.reset = function () {
    this.state = 'clustered';
    this.lastTime = 0;
    this.pendingScareStrength = 0;
    if (this.school) this.school.dataset.u20FishState = 'clustered';
    for (var i = 0; i < this.fishes.length; i += 1) {
      var fish = this.fishes[i];
      fish.mode = 'clustered';
      fish.node.dataset.u20FishMode = 'clustered';
      fish.x = 0;
      fish.y = 0;
      fish.vx = 0;
      fish.vy = 0;
      fish.escapeTravelScale = 1;
      fish.age = 0;
      fish.orbitClock = 0;
      fish.settleElapsed = 0;
      fish.settleStartX = 0;
      fish.settleStartY = 0;
      fish.settleTargetX = 0;
      fish.settleTargetY = 0;
      fish.repeatQueued = false;
      fish.repeatElapsed = 0;
      fish.repeatDuration = 0;
      fish.repeatStartX = 0;
      fish.repeatStartY = 0;
      fish.repeatTargetX = 0;
      fish.repeatTargetY = 0;
      fish.repeatWrap = false;
      fish.repeatWrapped = false;
      fish.repeatTravelDistance = 0;
      fish.orbitAge = 0;
      fish.repeatHoverArmed = false;
      fish.node.dataset.u20FishRepeatQueued = 'false';
      fish.swimPhase = fish.seed;
      this.setFastSwim(fish, false);
      fish.node.style.setProperty('--u20-fish-x', '0px');
      fish.node.style.setProperty('--u20-fish-y', '0px');
      fish.node.style.setProperty('--u20-fish-angle', '0deg');
      fish.node.style.setProperty('--u20-fish-facing', '1');
      fish.node.style.setProperty('--u20-fish-tail-angle', '0deg');
      fish.node.style.setProperty('--u20-fish-body-skew', '0deg');
      fish.node.style.setProperty('--u20-fish-body-roll', '0deg');
      fish.node.style.setProperty('--u20-fish-body-scale', '1');
      fish.node.style.setProperty('--u20-orbit-offset-x', '0px');
      fish.node.style.setProperty('--u20-orbit-offset-y', '0px');
      if (fish.context && fish.canvas) fish.context.clearRect(0, 0, fish.canvas.width, fish.canvas.height);
    }
  };

  GoldfishSchool.prototype.onResize = function () {
    this.syncAnimationState();
  };

  GoldfishSchool.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;

    this.stopTick();
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.stopPrewarmWatch();

    this.footer.removeEventListener('pointermove', this.onPointerMove);
    this.footer.removeEventListener('pointerdown', this.onPointerDown);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (typeof this.motionQuery.removeEventListener === 'function') {
      this.motionQuery.removeEventListener('change', this.onMotionPreferenceChange);
    } else {
      this.motionQuery.removeListener(this.onMotionPreferenceChange);
    }

    this.nearViewport = false;
    this.lastTime = 0;
  };

  function getFootersWithin(root) {
    var footers = [];
    if (!root) return footers;

    if (root.matches && root.matches(FOOTER_SELECTOR)) {
      footers.push(root);
    }
    if (root.querySelectorAll) {
      Array.prototype.push.apply(
        footers,
        Array.prototype.slice.call(root.querySelectorAll(FOOTER_SELECTOR))
      );
    }
    return footers;
  }

  function initWithin(root) {
    getFootersWithin(root).forEach(function (footer) {
      var existing = instances.get(footer);
      if (existing && !existing.destroyed) return;

      var instance = new GoldfishSchool(footer);
      instances.set(footer, instance);
    });
  }

  function destroyWithin(root) {
    getFootersWithin(root).forEach(function (footer) {
      var instance = instances.get(footer);
      if (instance) instance.destroy();
      instances.delete(footer);
    });
  }

  function onSectionLoad(event) {
    initWithin(event.target);
  }

  function onSectionUnload(event) {
    destroyWithin(event.target);
  }

  var runtime = {
    initWithin: initWithin,
    destroyWithin: destroyWithin,
    onSectionLoad: onSectionLoad,
    onSectionUnload: onSectionUnload
  };
  window[RUNTIME_KEY] = runtime;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () { initWithin(document); },
      { once: true }
    );
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
